import { Button } from "./components/ui/button/button";
import { Logo } from "./components/ui/logo/logo";

export function FatalErrorView({ error }: { error: Error }) {
  return (
    <div role="alert" className="flex flex-col h-full">
      <div className="bg-header p-3">
        <Logo />
      </div>
      <div className="flex flex-col grow gap-10 p-5 bg-primary-muted">
        <p className="text-3xl text-center">Something went wrong...</p>
        <Button
          className="w-60 self-center"
          onClick={() => window.location.reload()}
        >
          Reload page
        </Button>
        <div className="flex flex-col self-center gap-2 p-3 w-4/5 rounded-md border shadow-md">
          <span>
            Error:{" "}
            <span className="text-destructive">{error.name ?? "unkown"}</span>
          </span>
          {error.message && (
            <span>
              Reason: <span className="text-destructive">{error.message}</span>
            </span>
          )}
          {error.stack && (
            <p className="text-destructive whitespace-pre-wrap ">
              {error.stack}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
